import React, { useEffect, useMemo } from 'react'
import { LogoTransfix } from 'transfix-ui/components/LogoTransfix'
import { StringParam } from 'use-query-params'
import { callApi, ENDPOINTS } from 'utils/api/callApi'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { RequestLoginLinkForm } from 'components/RequestLoginLinkForm'
import { generateBaseUrl } from 'utils/generateAppDefaults'
import { useQueryParams } from 'utils/hooks'

export const RequestLink = () => {
  const { trackEvent } = useFMSAnalytics()
  // eslint-disable-next-line camelcase
  const [{ reset_password: resetPassword }] = useQueryParams({ reset_password: StringParam })

  const requestType = useMemo(
    () =>
      resetPassword === 'true' ? 'fleet_planner_reset_password_link' : 'fleet_planner_login_link',
    [resetPassword]
  )

  const submitLinkRequestHandler = async (email?: string) => {
    await callApi({
      endpoint: ENDPOINTS.password,
      method: 'POST',
      body: { email, type: requestType },
    })
    trackEvent('Login', 'REQUESTED_EMAIL_LINK')
  }
  const backToSignupClickHandler = () => trackEvent('Login', 'RETURNED_TO_SIGNUP')

  useEffect(() => trackEvent('Login', 'VIEWED_REQUEST_EMAIL_LINK'), [])

  return (
    <div className='flex justify-center'>
      <div className='flex flex-column col-sm-12 col-lg-3'>
        <div className='flex-grow-1 tc ma8'>
          <LogoTransfix color='black' />
        </div>
        <RequestLoginLinkForm
          onSubmitLink={submitLinkRequestHandler}
          onClickBackToSignup={backToSignupClickHandler}
          backToSignupUrl={generateBaseUrl('fms/login')}
          isResetPasswordRequest={resetPassword === 'true'}
        />
      </div>
    </div>
  )
}
